import { useState } from "react";
import { useSelector } from "react-redux";
import PageShell from "../../../components/PageShell";
import RecentCustomer from "../../../pages/customer/RecentCustomer";
import ActiveOnlineOrder from "../../../components/ActiveOnlineOrder";
import ImportPaperWallet from "../../../components/ImportPaperWallet";
import { useSubscribeUpdates } from "../../../hooks/useSubscribeUpdates";
import { selectCurrent } from "../../../store/customer";
import { useTranslation } from "../../../i18n";
import { VipStarIcon, CrownIcon } from "../../super/components/icons";

export default function RecentCustomerPage() {
  const customer = useSelector(selectCurrent);
  const [canBecomeVip, setCanBecomeVip] = useState();

  useSubscribeUpdates();

  return (
    <PageShell
      title={
        customer != null
          ? `${customer.firstname} ${customer.lastname || ""}`
          : ""
      }
      titleAppendix={
        customer &&
        customer.tierInfo?.vipEnabled && (
          <VipTierInfo
            isVip={customer.tierInfo?.tier === "vip"}
            endsAt={customer.tierInfo.endsAt}
            canBecomeVip={canBecomeVip}
          />
        )
      }
      actions={
        <div className="flex gap-4">
          <ActiveOnlineOrder />
          <ImportPaperWallet />
        </div>
      }
    >
      <RecentCustomer setCanBecomeVip={setCanBecomeVip} />
    </PageShell>
  );
}

const VipTierInfo = ({ isVip, endsAt, canBecomeVip }) => {
  const { t } = useTranslation();
  const formattedDate = endsAt
    ? new Date(endsAt).toLocaleDateString("ru-RU")
    : null;

  return (
    <div className="flex gap-3 items-center">
      <div
        className={`flex gap-2 ${isVip ? "bg-[#e6b63c]" : "bg-[#262b61]"} rounded-full px-3 py-1`}
      >
        {isVip ? <CrownIcon fill="#FFFFFF" /> : <VipStarIcon fill="#FFFFFF" />}
        <p className="font-bold">
          {isVip ? t("common.vip") : t("common.basic")}
        </p>
      </div>
      {isVip && formattedDate && (
        <span className="text-sm text-gray-400">
          {t("common.until")} {formattedDate}
        </span>
      )}
      {!isVip && canBecomeVip && <p>{t("common.canBecomeVipToday")}</p>}
    </div>
  );
};
